import type * as THREE from 'three';
import type { ShellFeatureDefinitionModel } from '../../../feature/definition/shell/ShellFeatureDefinition';
import type { ShellFeaturePrototype } from '../../../feature/prototype/shell/ShellFeaturePrototype';
import { FeaturePreviewObject } from '../FeaturePreviewObject';

/**
 * 抽壳预览体对象。
 */
export class ShellPreviewObject extends FeaturePreviewObject<
    ShellFeaturePrototype,
    ShellFeatureDefinitionModel
> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        prototype: ShellFeaturePrototype;
        draftDefinition: ShellFeatureDefinitionModel;
        meshData: MeshData;
        geometry: THREE.BufferGeometry;
        material: THREE.Material | THREE.Material[];
    }) {
        super(input);
    }
}
